import { Component, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

export interface AlertData {
	mensaje: string;
	text: boolean;
	title: string;
	mensajeHtml: string;
}

@Component({
	selector: "kt-alert",
	templateUrl: "./confirm.component.html",
	styleUrls: ["./confirm.component.scss"]
})
export class ConfirmComponent {

	@ViewChild("textarea") textarea: any;
	@ViewChild("okAutoFocus") okAutoFocus: any;

	public constructor(
		@Inject(MAT_DIALOG_DATA) public data: AlertData,
		public dialogRef: MatDialogRef<ConfirmComponent>) {
	}

	public ngAfterViewInit(): void {
		this.okAutoFocus.focus();
	}

	public ok(): void {
		if (this.data.text) {
			this.dialogRef.close({
				result: "ok",
				text: this.textarea.nativeElement.value,
			});
		}
		else {
			this.dialogRef.close("ok");
		}
	}

	public onNoClick(): void {
		this.dialogRef.close();
	}
}
